function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.764481 27.194917",
    height: "43.718414mm",
    width: "23.735306mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.23255502,0,0,0.23255502,-8.5868768,-14.669356)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#aaa",
      strokeWidth: 4
    },
    d: "m 37.431755,63.674623 62.476301,1.1e-5 -30.818919,114.870506 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 7
    },
    d: "M 36.953251,63.645253 H 100.34216"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle);
export default __webpack_public_path__ + "static/media/triangle.a38edf503594c8e114fd271c9d2892e8.svg";
export { ForwardRef as ReactComponent };